function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.4679 2.3999H20.5439C21.1319 2.3999 21.5999 2.8679 21.5999 3.4559V20.5439C21.5999 21.1199 21.1319 21.5999 20.5439 21.5999H15.6479V14.1599H18.1439L18.5159 11.2679H15.6479V9.4199C15.6479 8.5799 15.8879 8.0039 17.0879 8.0039H18.6239V5.4119C18.3599 5.3759 17.4479 5.3039 16.3919 5.3039C14.1719 5.3039 12.6599 6.6479 12.6599 9.1319V11.2679H10.1519V14.1599H12.6599V21.5999H3.4679C3.18672 21.5999 2.91687 21.489 2.71692 21.2913C2.51698 21.0936 2.40306 20.8251 2.3999 20.5439V3.4559C2.3999 2.8679 2.8799 2.3999 3.4679 2.3999Z",
  fill: "#395185"
});
function SvgIconFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFb);
export default __webpack_public_path__ + "static/media/iconFb.435570fd.svg";
export { ForwardRef as ReactComponent };